var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.084 15.53a2.015 2.015 0 01-.335-2.358 3.265 3.265 0 00.088-2.856 3.224 3.224 0 00-2.205-1.807 1.992 1.992 0 01-1.54-1.798 3.204 3.204 0 00-4.288-2.772 2.005 2.005 0 01-2.254-.668 3.192 3.192 0 00-5.098 0 2.007 2.007 0 01-2.254.668 3.204 3.204 0 00-4.287 2.773A1.993 1.993 0 015.369 8.51a3.226 3.226 0 00-2.205 1.806 3.268 3.268 0 00.088 2.858 2.013 2.013 0 01-.335 2.356 3.239 3.239 0 00.725 5.075 2.003 2.003 0 01.979 2.164 3.261 3.261 0 00.713 2.768 3.19 3.19 0 002.624 1.107l.124-.004a1.997 1.997 0 011.853 1.288 3.228 3.228 0 002.088 1.941 3.188 3.188 0 002.803-.496 2.005 2.005 0 012.349 0 3.19 3.19 0 002.803.497 3.23 3.23 0 002.087-1.942 2 2 0 011.854-1.288l.125.004c.067.004.135.007.204.007a3.194 3.194 0 002.419-1.114 3.262 3.262 0 00.713-2.768 2.006 2.006 0 01.98-2.165 3.236 3.236 0 00.724-5.073zm-5.288-2.779L14.03 22.779a.3.3 0 01-.424.006l-.006-.006-5.396-5.542a.3.3 0 010-.418l2.057-2.113a.3.3 0 01.424-.006l.006.006 3.124 3.208 7.493-7.693a.3.3 0 01.424-.006l.006.006 2.058 2.111a.3.3 0 010 .419z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--travel-guarantee-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'TravelGuaranteeIcon';
export default Icon;